function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as o } from "./index.es33.js";
import { useState as y, useEffect as j } from "react";
import { t as e } from "./index.es106.js";
import { Typography as h } from "./index.es35.js";
import { palette as T } from "./index.es36.js";
import { Confirm as V } from "./index.es46.js";
import { BaseInput as g } from "./index.es62.js";
import { Label as p } from "./index.es44.js";
import { SelectDropDown as v } from "./index.es19.js";
import { useFormHandlers as L, useVariableTypeOptions as B } from "./index.es495.js";
import { Button as r } from "./index.es5.js";
import { removeReservedSymbols as M } from "./index.es496.js";
import i from "./index.es497.js";

var q = function q(_ref) {
  var _ref$defaultName = _ref.defaultName,
      a = _ref$defaultName === void 0 ? "" : _ref$defaultName,
      s = _ref.existingVariables,
      l = _ref.onClose,
      c = _ref.onSave,
      d = _ref.isAddVariablePending;

  var _y = y({
    name: "",
    type: "string"
  }),
      _y2 = _slicedToArray(_y, 2),
      t = _y2[0],
      n = _y2[1];

  j(function () {
    n(_objectSpread(_objectSpread({}, t), {}, {
      name: M(a)
    }));
  }, [a]);

  var _L = L({
    formValue: t,
    setFormValue: n,
    onSave: c,
    existingVariables: s
  }),
      m = _L.error,
      _ = _L.onNameChange,
      b = _L.onSaveClick,
      _B = B(t.type),
      u = _B.currentType,
      x = _B.typeOptions;

  return o.jsxs(V, {
    title: e("component_component_popupMenu_addCustomVariableLabel"),
    onClose: l,
    children: [o.jsxs("div", {
      className: i.content,
      children: [o.jsx(g, {
        label: o.jsx(p, {
          label: e("component_component_addVariableModal_variableNameLabel"),
          withRequiredSign: !0
        }),
        value: t.name,
        placeholder: e("component_enterTextField_textPromptLabel_enterNamePromptLabel"),
        onChange: _,
        maxLength: 60,
        isError: !!m,
        hint: m
      }), o.jsx(v, {
        label: o.jsx(p, {
          label: e("component_component_addVariableModal_typeLabel"),
          tooltipInfoText: o.jsxs(h.Body2, {
            color: T.gray5,
            children: [e("component_component_addVariableModal_typeTooltipStringText"), " ", o.jsx("br", {}), e("component_component_addVariableModal_typeTooltipNumberText"), " ", o.jsx("br", {}), e("component_component_addVariableModal_typeTooltipDatetimeText")]
          })
        }),
        value: u,
        options: x,
        onSelect: function onSelect(f) {
          return n(_objectSpread(_objectSpread({}, t), {}, {
            type: f.value
          }));
        }
      })]
    }), o.jsxs("div", {
      className: i.buttonsRow,
      children: [o.jsx(r, {
        kind: r.ButtonKind.outline,
        onClick: l,
        children: e("component_commonKeys_cancelButton_cancelButton")
      }), o.jsx(r, {
        isLoading: d,
        onClick: b,
        children: e("component_component_addVariableModal_addButtonLabel")
      })]
    })]
  });
};

export { q as VariableModal };